/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper } from 'sarsaparilla';
import * as globals from '../constants/globals';
import {
    POST_AI_REVIEW_VOTE_FAILURE,
    POST_AI_REVIEW_VOTE_START,
    POST_AI_REVIEW_VOTE_SUCCESS,
} from '../constants/types';
import { makeAsyncAction } from '../utils/async_utils';

export type aiVoteRequest = {
    reservation_id: string;
    location_id: string;
    location_type: string;
    is_helpful: boolean;
    vote_changed: boolean;
};

export const postAIReviewVoteEndpoint = () => `${globals.API_URL}/summary/helpful/vote`;

const postAIReviewVoteApi = (data: aiVoteRequest) => () =>
    axios.post(postAIReviewVoteEndpoint(), data, {
        headers: { Authorization: SecurityHelper.getAuthHeader() },
    });

export const postAIReviewVote = makeAsyncAction(
    {
        startType: POST_AI_REVIEW_VOTE_START,
        successType: POST_AI_REVIEW_VOTE_SUCCESS,
        failureType: POST_AI_REVIEW_VOTE_FAILURE,
    },
    postAIReviewVoteApi,
    true,
    'data'
);
